import { SHOW_TOAST, HIDE_TOAST } from "actions/global-toast-action";
const initState = {
  toast: {},
  isVisible: false,
  isProcessing: false,
};

export const globalToastReducer = (state = initState, action) => {
  switch (action.type) {
  case SHOW_TOAST:
    return {
      ...state,
      isVisible: true,
      toast: { type: action.payload.type, message: action.payload.message},
      isProcessing: action.payload.isProcessing,
    };
  case HIDE_TOAST:
    return {
      ...state,
      isVisible: false,
      toast: null, 
      isProcessing: false,
    };
  default:
    return state;
  }
}